import { render } from "./NewSpent.vue?vue&type=template&id=c8ebf846&ts=true"
import script from "./NewSpent.vue?vue&type=script&lang=ts"
export * from "./NewSpent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__